export default __webpack_public_path__ + "03d8ed2a9f0213e9958bc625965d0a87.png";